import { getAuthAxiosBackend } from "@/helpers/axios"

class SelfEmploymentServices{

    get(id){
        return getAuthAxiosBackend().get('SelfEmployment/getSelfEmployment/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('SelfEmployment/getSelfEmploymentByPersonId/' + personId.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('SelfEmployment/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('SelfEmployment/addSelfEmployment', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('SelfEmployment/updateSelfEmployment/' + id.toString(), data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('SelfEmployment/softDeleteSelfEmployment/' + id.toString())
    }
}

export default new SelfEmploymentServices()